module.exports = global["rangy"] = require("-!./rangy-core.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?rangy!./~/rangy/lib/rangy-core.js
// module id = 523
// module chunks = 6